import { defineStore } from 'pinia';
import { useAdvisorStore } from './advisorStore.js';

export const useFirmStore = defineStore('firm', {
  state: () => ({
    hasFetched: false,
    isFetching: false,
    isUpdatingAdvisor: [],
    advisors: [],
  }),

  actions: {
    setAdvisors(advisors) {
      this.advisors = advisors;
      this.hasFetched = true;
    },

    setFetching(newValue) {
      this.isFetching = newValue;
    },

    setUpdatingAdvisor(advisorExternalId, adding = true) {
      if (adding) {
        if (!this.isUpdatingAdvisor.includes(advisorExternalId)) {
          this.isUpdatingAdvisor.push(advisorExternalId);
        }
      } else {
        const idx = this.isUpdatingAdvisor.indexOf(advisorExternalId);

        if (idx !== -1) {
          this.isUpdatingAdvisor.splice(idx, 1); // Vue 2 reactivity
        }
      }
    },

    mergeAdvisorFields(externalId, partial) {
      const idx = this.advisors.findIndex(a => a.external_id === externalId);

      if (idx === -1) {
        return;
      }

      const updated = { ...this.advisors[idx], ...partial };
      this.advisors.splice(idx, 1, updated);
    },

    // Network actions
    async fetchAdvisors() {
      this.setFetching(true);

      try {
        const response = await fetch(`/api/v1/advisors/`);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        this.setAdvisors(data.advisors);
      } catch (error) {
        console.error('Error fetching teams:', error);
        this.setAdvisors([]);
      } finally {
        this.setFetching(false);
      }
    },

    async updateAdvisorPrivileges(advisorExternalId, payload) {
      if (!advisorExternalId || !payload) {
        return;
      }

      const advisorStore = useAdvisorStore();
      this.setUpdatingAdvisor(advisorExternalId, true);

      try {
        const response = await fetch(
            `/api/v1/advisors/${advisorExternalId}/privileges/`,
            {
              method: 'PATCH',
              body: JSON.stringify(payload),
              headers: advisorStore.headers,
            },
        );

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        this.mergeAdvisorFields(advisorExternalId, data);
      } catch (error) {
        console.error(`Error updating advisor privileges:`, error);
      } finally {
        this.setUpdatingAdvisor(advisorExternalId, false);
      }
    },
  },
});
